export default {
  MIN: 1,
  MAX: 99,
};
